<!--
 * @Author: Gaho
 * @Date: 2024-01-10 15:30:10
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-23 15:20:35
 * 空数据组件
-->
<template>
    <div class="empty">
        <slot></slot>
        <p class="empty-content">
            {{ content || useTranslation().Noinformation }}
        </p>
    </div>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
const props = defineProps({
    content: { // 下方的内容
        type: String,
        default: '',
    }
})
</script>

<style lang="scss" scoped>
.empty {
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 44px;
    min-height: 200px;

    .empty-content {
        color: var(--color_grey-40);
        font-weight: 600;
        text-align: center;
        // white-space: nowrap;
        user-select: none;
        white-space: normal;
    }
}

</style>